import { render, staticRenderFns } from "./hallway.vue?vue&type=template&id=3da0520a&"
import script from "./hallway.vue?vue&type=script&lang=js&"
export * from "./hallway.vue?vue&type=script&lang=js&"
import style0 from "./hallway.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "hallway.vue"
export default component.exports